import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import classes from '../Shared/Container.module.css'
import WorkersCompItemV2 from "./WorkersCompItemV2";

const WorkersCompDetails = () => {
    const activeCase = useSelector(state => state.case.activeCase)        

    const [data, setData] = useState(null)

    useEffect(() => {
        if (activeCase) {          
      
            setData(activeCase.worker_comp)
        }
    }, [activeCase])

    return <div className={classes.container}>
        {data && <WorkersCompItemV2 data={data} apiCase={'case_worker_comp'}/>}
    </div>
}

export default WorkersCompDetails